/**
 * Варианты ответа (F/G): столбик полноширинных кнопок с текстом слева,
 * выбранный — `.active` на мягкой охре; подсказка и пометки — второй
 * строкой в 12px. Выключенный вариант остаётся на экране (экзамен:
 * «вспомнили: не то»). Группа подписана `aria-label`.
 */
export interface ChoiceItem {
  /** Текст варианта (уже переведённый). */
  text: string;
  /** Пометка справа (переведённая): подсказка, шанс, цена. */
  note?: string;
  disabled?: boolean;
}

export interface ChoiceProps {
  label: string;
  items: ChoiceItem[];
  value: number | null;
  onChange: (i: number) => void;
  disabled?: boolean;
}

export function Choice({ label, items, value, onChange, disabled = false }: ChoiceProps) {
  return (
    <div class="picks column choice" role="group" aria-label={label}>
      {items.map((item, i) => (
        <button
          type="button"
          key={i}
          class={`btn${value === i ? ' active' : ''}`}
          aria-pressed={value === i}
          disabled={disabled || item.disabled === true}
          onClick={() => onChange(i)}
        >
          <span>{item.text}</span>
          {item.note && <span class="note">{item.note}</span>}
        </button>
      ))}
    </div>
  );
}
